var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',{staticClass:"save"},_vm._l((_vm.iconList),function(item){return _c('li',{key:item.title},[_c('div',[_c('img',{attrs:{"src":item.url,"alt":""}})]),_c('p',[_vm._v(_vm._s(item.title))])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }